import { render, staticRenderFns } from "./addChainMerchant.vue?vue&type=template&id=40b3ccd7&scoped=true&"
import script from "./addChainMerchant.vue?vue&type=script&lang=js&"
export * from "./addChainMerchant.vue?vue&type=script&lang=js&"
import style0 from "./addChainMerchant.vue?vue&type=style&index=0&id=40b3ccd7&scoped=true&lang=css&"
import style1 from "./addChainMerchant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3ccd7",
  null
  
)

export default component.exports